/* unplugin-vue-components disabled */import script from "./CancellationManage.vue?vue&type=script&setup=true&lang=js"
export * from "./CancellationManage.vue?vue&type=script&setup=true&lang=js"

import "./CancellationManage.vue?vue&type=style&index=0&id=574e43ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574e43ea"]])

export default __exports__